import { createContext, ReactNode, useContext, useEffect } from 'react';

import { newRelicMonitoringService } from 'services';

import packageJson from '../../../package.json';
import { brandInitialState } from '../brand';
import { userInitialState } from '../user';

const initialState = {
  user: userInitialState,
  brand: brandInitialState,
};
type InitialState = typeof initialState & {
  document?: string;
};

export const GlobalContext = createContext<InitialState>(initialState);

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalContextProvider = ({
  children,
  state,
}: {
  children: ReactNode;
  state: Partial<InitialState>;
}) => {
  useEffect(() => {
    if (!state.user?.resellerId) {
      return;
    }
    newRelicMonitoringService.setUserId(state.user?.resellerId);
    newRelicMonitoringService.addCustomAttribute('selfServiceMFVersion', packageJson.version, true);
  }, [state?.user?.resellerId]);

  return (
    <GlobalContext.Provider
      value={{
        user: state.user || initialState.user,
        brand: state.brand || initialState.brand,
        document: state.document,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
